module.exports = "//static.hsappstatic.net/FormsUI/static-2.23336/img/editor/linked-rows-icon.svg"